module.exports = __webpack_public_path__ + "img/picto-supprimer-disabled.2b10c45c.svg";